import React, { ReactElement } from 'react';
import {
  Button,
  Box,
  Text,
  AlertTriangleIcon,
} from '@razorpay/blade/components';

export const ErrorAlert = ({
  mainText,
  subText,
  buttonText,
  downloadURL,
  onClick,
}: {
  mainText: string;
  subText: string;
  buttonText?: string;
  downloadURL?: string;
  onClick?: () => void;
}): ReactElement => {
  return (
    <Box
      backgroundColor="surface.background.gray.intense"
      borderColor="surface.border.gray.muted"
      borderWidth="thin"
      borderRadius="medium"
      padding="spacing.5"
      marginTop="spacing.5">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Box display="flex" alignItems="center">
            <AlertTriangleIcon color="feedback.icon.negative.intense" />
            <Text
              size="small"
              weight="semibold"
              color="surface.text.gray.normal"
              marginLeft="spacing.3">
              {mainText}
            </Text>
          </Box>
          <Text size="small" weight="regular" color="surface.text.gray.muted" marginTop="spacing.2">
            {subText}
          </Text>
        </Box>
        {buttonText ? (
          <Button
            size="xsmall"
            variant="secondary"
            onClick={() => {
              onClick?.();
              downloadURL && window.open(downloadURL, '_blank');
            }}>
            {buttonText}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};
